import React from 'react';
import { Box, Text } from '@mantine/core';

interface PodcastPlayerProps {
  podcastId?: string;
}

const PodcastPlayer: React.FC<PodcastPlayerProps> = ({ podcastId }) => {
  if (!podcastId) {
    return <Text color="dimmed">No podcast available for this post.</Text>;
  }

  return (
    <Box
      mb="md"
      style={{
        width: '100%',
        height: 170,
        borderRadius: 10,
        overflow: 'hidden',
      }}
    >
      <iframe
        style={{
          width: '100%',
          height: 170,
        }}
        frameBorder="0"
        scrolling="no"
        seamless
        src={`https://player.captivate.fm/episode/${podcastId}`}
        title="Podcast player"
      />
    </Box>
  );
};

export default PodcastPlayer;
